import { AdSlot } from "react-dfp";
import dynamic from "next/dynamic";
import classNames from "classnames";

import styles from "../Advertisement.module.scss";

export const AuthorBottomAd: React.FC<{ isList?: boolean }> = ({
  isList = true,
}) => {
  const sizes =
    window.innerWidth < 768
      ? [
          [300, 400],
          [300, 250],
          [300, 50],
        ]
      : [
          [1140, 300],
          [796, 200],
          [693, 200],
        ];

  return (
    <div className={classNames(styles.authorBottom, !isList && styles.page)}>
      <AdSlot adUnit={`newoncev3_redaktorzy2`} sizes={sizes} />
    </div>
  );
};

export default dynamic(() => Promise.resolve(AuthorBottomAd), { ssr: false });
